import React from 'react';
import OwnerPortalLateralMenu from '../LateralMenu/OwnerPortalLateralMenu';

const OwnerPortalContainer = ({ children }) => {
    return (
        <div className='owner-portal__content'>
            <OwnerPortalLateralMenu />
            <section className='owner-portal__content-container'>
                {children}
            </section>
        </div>
    );
};

export default OwnerPortalContainer;
